import Component from 'vue-class-component';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'created',
]);



// WEBPACK FOOTER //
// ./src/hooks.ts